<script setup>
import {onMounted} from "vue";
import {useGlobalStore} from "@/stores/global.store";
import {useReportStore} from "@/stores/report.store";
import {storeToRefs} from "pinia";

const globalStore = useGlobalStore();
const userReportStore = useReportStore();
const {reports} = storeToRefs(userReportStore);

onMounted(async () => {
    globalStore.loading = true;
    await useReportStore().fetchAll();
    globalStore.loading = false;
});

const redirectTo = (url) => {
    window.location.href = url;
}

</script>

<template>
    <van-space direction="vertical" fill>
        <div v-if="reports.length > 0">
            <van-cell-group inset v-for="report in reports"
                            :key="report.id">
                <van-cell>
                    <template #title>
                        <b>{{ report.name }}</b>
                    </template>
                </van-cell>
                <van-cell title="Created" :value="report.created_at_formatted"/>
                <van-cell is-link @click="redirectTo(report.ssr_url)" title="View"/>
                <van-row>&nbsp;</van-row>
            </van-cell-group>
        </div>
    </van-space>
</template>
